<template>
    <div :class="!audit_mode && !previous ? 'mb-5' : 'gray-600 font-scale-sm'">
        <div :class="[{ 'gray-500 rounded border border-color-gray-300 bgray-100 p-3': previous }]">
            <b-overlay :show="is_visible_by_pipeline === false"
                       rounded="sm"
                       opacity="0.8"
                       bg-color="#efefef"
            >
                <div v-if="headers">
                    <div class="d-flex align-items-center mb-1 pb-1">
                        <b-badge class="f-80" variant="basic">
                            <template v-if="is_edit_page && label">
                                {{ sub_code_label }}. ( {{ sub_code }} )
                            </template>
                            <template v-else>
                                {{ sub_code_label }}.
                            </template>
                        </b-badge>

                        <template v-if="required_attachment">
                            <b-badge variant="danger" class="f-85 fw-500 ml-1"> {{ $t('첨부필수') }}</b-badge>
                        </template>

                        <template v-if="required_answer">
                            <b-badge variant="warning" class="f-85 fw-500 ml-1"> {{ $t('필수답변') }}</b-badge>
                        </template>

                        <template v-if="!isFieldEmpty(sub_info) && previous !== true">
                            <b-button class="f-80 ml-1 px-1 py-0" variant="teal" size="sm"
                                      :aria-expanded="is_visible ? 'true' : 'false'"
                                      :aria-controls="`sub_info-${sub_code}`"
                                      @click="toggleVisible"
                            >
                                <fa icon="book-open"></fa>
                                {{ $t('작성 도움말') }}
                            </b-button>
                        </template>
                    </div>

                    <!-- sub_info 정보 -->
                    <template v-if="!isFieldEmpty(sub_info)">
                        <div v-show="is_visible"
                             :id="`sub_info-${sub_code}`"
                             class="mb-2 rounded px-3 py-1 bg-blue2 blue7 f-90"
                        >
                            <span v-html="showTranslation(sub_info, sub_info_e, sub_info_c)"></span>
                        </div>
                    </template>

                    <div :class="isFieldEmpty(sub_description) ? 'mb-45 pt-1': 'mb-1'">
                        <div v-if="is_indicate_description" class="mr-1 d-inline f-105">
                            {{ showTranslation(sub_description, sub_description_e, sub_description_c) }}
                        </div>
                        <span v-for="item in tags" :key="item.id">
                            <span v-if="!isFieldEmpty(item)" class="ml-2 f-80 gray-500"> {{ item }} </span>
                        </span>
                        <span v-if="!isFieldEmpty(sub_priority)">
                            <b-button variant="icon" class="mx-2">{{ sub_priority }}</b-button>
                        </span>
                        <!-- sub_condition -->
                        <!-- <div v-if="is_sub_condition_activated==true" :id="`sub_condition-${sub_code}`" class="my-2 py-2">
                            <b-form-checkbox :disabled="is_locked || is_disabled_by_parent" v-model="sub_condition.value" @change="radioSave()"> {{ sub_condition.text }} </b-form-checkbox>
                        </div> -->
                    </div>
                </div>

                <!-- CheckBox 유형 Sub Component-->
                <b-form-checkbox-group :id="form_id"
                                       v-model="sub_data_contents.result"
                                       @change="handleChange"
                                       stacked
                >
                    <b-row v-for="(checkbox_option, index) in sub_data_contents.structure"
                           :key="`checkbox-${sub_code}-option-${index}`"
                           no-gutters
                    >
                        <b-col cols="12" class="mb-1">
                            <b-form-checkbox
                                :value="checkbox_option.value"
                                :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                            >
                                    <span
                                        v-html="showTranslation(checkbox_option.text, checkbox_option.text_ea, checkbox_option.text_ca)"></span>
                            </b-form-checkbox>


                        </b-col>
                        <div v-if="has_sub_attachment(checkbox_option)" class="w-100 rounded mb-3 border-0 f-95 p-2 bg-tealgray100">

                            <df-attached-file-url-sub
                                class="mt-1"
                                :key="is_loaded"
                                :sub_id="sub_id"
                                :sub_code="sub_code"
                                :sub_init_id="sub_init_id"
                                :sub_path="`structure[${index}]`"
                                :company_id="company_id"
                                :company_name="company_name"
                                :campaign_id="campaign_id"
                                :audit_mode="audit_mode"
                                :previous="previous"
                                :sub_data_contents="sub_data_contents"
                                :save_state="save_state"
                                :label="label"
                                :required_opt_attachment="sub_data_header.required_opt_attachment"
                                :disabled="is_disabled_attached || !sub_data_contents.result"
                            >
                            </df-attached-file-url-sub>
                        </div>

                        <template
                            v-if="typeof checkbox_option.description !== 'undefined' && checkbox_option.description !== null">
                            <b-col cols="11" class="mb-2">
                                <b-input-group
                                    class="ml-4"
                                >
                                    <template
                                        v-if="checkbox_option?.description_input_type && checkbox_option.description_input_type === 'number'">
                                        <b-form-input class="f-90"
                                                      v-model="checkbox_option.description"
                                                      :type="checkbox_option.description_input_type"
                                                      @update="textInputSave"
                                                      :placeholder="!isFieldEmpty(checkbox_option.placeholder) ? showTranslation(checkbox_option.placeholder, checkbox_option.placeholder_ea, checkbox_option.placeholder_ca) : `${ $t('상세설명') }`"
                                                      :disabled="!sub_data_contents.result.includes(checkbox_option.value) || is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                        >
                                        </b-form-input>
                                    </template>
                                    <template v-else>
                                        <b-form-input class="f-90"
                                                      v-model="checkbox_option.description"
                                                      :type="typeof checkbox_option.description_input_type === 'undefined' ? 'text' : checkbox_option.description_input_type"
                                                      @update="textInputSave"
                                                      :placeholder="!isFieldEmpty(checkbox_option.placeholder) ? showTranslation(checkbox_option.placeholder, checkbox_option.placeholder_ea, checkbox_option.placeholder_ca) : `${ $t('상세설명') }`"
                                                      :disabled="!sub_data_contents.result.includes(checkbox_option.value) || is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                        >
                                        </b-form-input>
                                    </template>


                                    <b-input-group-append>
                                        <b-button
                                            v-b-modal="`checkbox-text-${sub_code}-${index}`"
                                            size="sm"
                                            variant="icon-append"
                                            :title="$t('상세 입력')"
                                            :aria-label="$t('상세 입력')"
                                            :disabled="!sub_data_contents.result.includes(checkbox_option.value)  || is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                                        >
                                            <fa icon="pen"></fa>
                                        </b-button>
                                    </b-input-group-append>
                                    <!-- 원본이 아니라 draft 를 고친다 — 확인 때만 반영·저장, 취소·닫기는 버린다 -->
                                    <b-modal
                                        :id="`checkbox-text-${sub_code}-${index}`"
                                        :title="checkbox_option.value ? checkbox_option.value : $t('텍스트 상세입력')"
                                        @show="modal_draft = checkbox_option.description"
                                        @ok="applyModalDraft(checkbox_option, 'description')"
                                        size="lg"
                                    >
                                        <div>
                                            <p class="mb-2 pl-1 f-90"> {{ $t('상세설명을 작성하여 주십시오.') }} </p>
                                            <b-textarea rows="5" v-model="modal_draft"></b-textarea>
                                        </div>
                                    </b-modal>
                                </b-input-group>
                            </b-col>
                        </template>
                    </b-row>
                </b-form-checkbox-group>

                <!-- file 저장 -->
                <template v-if="sub_data_header.has_attachment">
                    <df-attached-file-url
                        class="mt-3"
                        :sub_id="sub_id"
                        :sub_code="sub_code"
                        :sub_init_id="sub_init_id"
                        :company_id="company_id"
                        :company_name="company_name"
                        :campaign_id="campaign_id"
                        :disabled="is_disabled_attached"
                        :audit_mode="audit_mode"
                        :previous="previous"
                        :has_attachment="sub_data_header.has_attachment"
                        :label="label"
                        :key="is_loaded"
                    >
                    </df-attached-file-url>
                </template>

                <!--validation-->
                <div v-if="previous !== true && audit_mode !== true"
                     :class="validation_style" @click="retrySave"
                     class="pt-2 float-right"
                     role="status" aria-live="polite"
                >
                    <fa v-if="validation_icon !== ''" :icon="validation_icon"></fa>
                    {{ validation_comment }}
                </div>

                <!-- Child Component -->
                <sub-component v-for="(item, index) in child_subs"
                               :key="item.id"
                               :is_final_sub_component="index == child_subs.length -1 ? true : false"
                               :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent"
                               :sub_type="item.sub_type"
                               :item="item"
                               :audit_mode="audit_mode"
                               :is_disabled_by_parent="is_disabled_by_parent">
                </sub-component>

                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <DFPipelineOverlay :prev_sub_info="prev_sub_info"
                                       :pipeline_title="pipeline_title"
                    />
                </template>
            </b-overlay>

        </div>

    </div>
</template>


<script>
import {SubComponentMixin} from '@core_mixins/SubComponentMixin'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";
import DfAttachedFileUrlSub from "@core/components/client/components/subs/elements/DFAttachedFileURLSub.vue";
import {mapActions, mapState} from "vuex";
import {unlinkWarning} from "@core/utils/subComponent/unlinkWarning";

export default {
    name: 'df-checkbox',
    mixins: [
        SubComponentMixin
    ],
    components: {
        DFPipelineOverlay,
        DfAttachedFileUrlSub
    },
    data() {
        return {
            // 첨부 해제 경고를 취소했을 때 되돌릴 직전 확정 선택값
            confirmed_result: [],
            pending_unlink_confirm: false
        }
    },
    watch: {
        'sub_data_contents.result': {
            immediate: true,
            handler(new_result) {
                if (!this.pending_unlink_confirm && Array.isArray(new_result)) {
                    this.confirmed_result = [...new_result]
                }
            }
        }
    },
    computed: {
        ...mapState('questions', ['subs']),
        has_sub_attachment() {
            return (item) => {
                return this.sub_data_header.required_opt_attachment && this.sub_data_contents.result.includes(item.value) && this.sub_id
            }
        },
    },
    methods: {
        ...mapActions('attachments', ['unlinkAttachments']),
        async handleChange() {
            let unlink_sub_attachments_obj = {}
            const temp_sub_data_contents = JSON.parse(JSON.stringify(this.sub_data_contents))
            // 현 항목 첨부파일 제거
            temp_sub_data_contents.structure.forEach((item, itemIdx) => {
                if (typeof item.attachments !== 'undefined') {
                    if (!this.sub_data_contents.result.includes(item.value)) {
                        // 선택한 답안이 아니면
                        item.attachments.forEach((attachment) => {
                            const sub_path = `structure[${itemIdx}]`
                            unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                sub_path,
                                storage_id: attachment
                            }
                        })
                        item.attachments = []
                    }
                }
            })

            const unlink_sub_attachments = Object.values(unlink_sub_attachments_obj)
            if(unlink_sub_attachments.length > 0){
                const h = this.$createElement;

                this.pending_unlink_confirm = true
                unlinkWarning(this, h)
                    .then(async (value) => {
                        this.pending_unlink_confirm = false
                        if(!value) {
                            this.sub_data_contents.result = [...this.confirmed_result]
                            return
                        }
                        this.confirmed_result = [...this.sub_data_contents.result]
                        const promiseList = []
                        unlink_sub_attachments.forEach(elem => {
                            promiseList.push(
                                this.unlinkAttachments({
                                    sub_id: this.sub_id,
                                    company_id: this.company_id.toString(),
                                    campaign_id: this.campaign_id.toString(),
                                    sub_path: elem.sub_path,
                                    storage_id: [elem.storage_id],
                                })
                            )
                        })
                        await Promise.all(promiseList)
                        await this.proceedCheckboxSave(temp_sub_data_contents)
                    })
            }
            else {
                await this.proceedCheckboxSave()
            }
        },
        async proceedCheckboxSave(temp_sub_data_contents){
            if(temp_sub_data_contents){
                const target_sub_idx = this.subs.findIndex(x => x.sub_code === this.sub_code)
                if(target_sub_idx >= 0){
                    this.$set(this.subs[target_sub_idx], 'sub_data_contents', temp_sub_data_contents)
                }
            }
            //calculate score
            this.$nextTick(() => {
                if (this.sub_data_header.scoring && this.sub_data_header.scoring === 'auto') {
                    let temp_score = 0

                    this.sub_data_contents.result.forEach(item => {
                        let idx = this.sub_data_contents.structure.findIndex(x => x.value === item)
                        if (idx > -1) {
                            if (this.sub_data_contents.structure[idx].score) {
                                temp_score += Number(this.sub_data_contents.structure[idx].score)
                            }
                        }
                    })
                    this.score_result = temp_score
                }
            })

            await this.radioSave()

        },
    }
}


</script>

<style>

</style>
